// @ts-nocheck
/* eslint-disable react/prop-types */
/**
 * SolyticsListVirtualized.jsx
 * INTERNAL COMPONENT - Renders massive datasets using absolute positioning and scroll-window math.
 */
import React, { useCallback } from 'react';
import { useVirtualizer } from '@tanstack/react-virtual';
import SolyticsListItem from '../../SolyticsListItem';

const SolyticsListVirtualized = ({
  items,
  variant,
  dense,
  gap,
  enableDragAndDrop,
  handleDrop,
  listElement,
}) => {
  // stable function reference, no closure over items
  const estimateSize = useCallback(() => {
    return (dense ? 36 : 44) + (gap ? gap * 8 : 0);
  }, [dense, gap]);

  // stable function reference for scroll element
  const getScrollElement = useCallback(() => listElement, [listElement]);

  const rowVirtualizer = useVirtualizer({
    count: items.length,
    getScrollElement,
    estimateSize,
    overscan: 5,
  });

  return (
    // We have to use plain div here in virtual list case so that there is less overhead of MUI during list rendering, MUI components also use absolute positioning and can conflict with virtualizer.
    <div
      style={{
        height: `${rowVirtualizer.getTotalSize()}px`,
        width: '100%',
        position: 'relative',
      }}
    >
      {rowVirtualizer.getVirtualItems().map((virtualRow) => {
        const item = items[virtualRow.index];
        return (
          // CRITICAL FIX: Must be a native div to preserve TanStack's DOM control
          <div
            key={item.id ?? `virtual-item-${virtualRow.index}`}
            ref={rowVirtualizer.measureElement}
            data-index={virtualRow.index}
            style={{
              position: 'absolute',
              top: 0,
              left: 0,
              width: '100%',
              paddingBottom: gap ? `${gap * 8}px` : undefined,
              transform: `translateY(${virtualRow.start}px)`,
            }}
          >
            <SolyticsListItem
              index={virtualRow.index}
              item={{ dense, variant, ...item }}
              draggable={enableDragAndDrop}
              onDrop={handleDrop}
            />
          </div>
        );
      })}
    </div>
  );
};

export default SolyticsListVirtualized;
